module.exports = __webpack_public_path__ + "img/low_poly.01777a33.jpg";